import { useState, useEffect } from 'react'
import firebase from 'firebase/app'
import 'firebase/storage'
import { v4 as uuidv4 } from 'uuid'

const firebaseConfig = {
	storageBucket: 'wohelo-yearbooks.appspot.com',
}

firebase.initializeApp(firebaseConfig)

function Gallery({ match }) {
	const [imageURLs, setImageURLs] = useState([])
	const [selectedImg, setSelectedImg] = useState(null)

	const storageRef = firebase.storage().ref(match.params.bookName)

	useEffect(() => {
		storageRef
			.listAll()

			.then((result) => {
				result.items.forEach((imageRef) => {
					imageRef
						.getDownloadURL()

						.then((url) => {
							setImageURLs((oldArray) => [...oldArray, url])
						})

						.catch((error) => console.error(error))
				})
			})

			.catch((error) => console.error(error))
	}, [])

	const Modal = () => {
		return (
			<div
				className='backdrop'
				onClick={(e) => {
					if (e.target.classList.contains('backdrop')) {
						setSelectedImg(null)
					}
				}}>
				<img src={selectedImg} alt='' />
			</div>
		)
	}

	return (
		<div className='App'>
			<div className='img-grid'>
				{imageURLs.map((imageURL) => {
					return (
						<div className='img-wrap' key={uuidv4()}>
							<img
								src={imageURL}
								onClick={() => setSelectedImg(imageURL)}
								alt=''
							/>
						</div>
					)
				})}
			</div>
			{selectedImg && <Modal />}
		</div>
	)
}

export default Gallery
